var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarArrowRotated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    transform: "matrix(-1 0 0 -1 32 32)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#0D234D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5714 22.8191C13.3814 22.8191 13.1914 22.7491 13.0414 22.5991L6.97141 16.5291C6.68141 16.2391 6.68141 15.7591 6.97141 15.4691L13.0414 9.39914C13.3314 9.10914 13.8114 9.10914 14.1014 9.39914C14.3914 9.68914 14.3914 10.1691 14.1014 10.4591L8.56141 15.9991L14.1014 21.5391C14.3914 21.8291 14.3914 22.3091 14.1014 22.5991C13.9614 22.7491 13.7614 22.8191 13.5714 22.8191Z",
    fill: "#099BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4999 16.75H7.66992C7.25992 16.75 6.91992 16.41 6.91992 16C6.91992 15.59 7.25992 15.25 7.66992 15.25H24.4999C24.9099 15.25 25.2499 15.59 25.2499 16C25.2499 16.41 24.9099 16.75 24.4999 16.75Z",
    fill: "#099BFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarArrowRotated);
export default __webpack_public_path__ + "static/media/sidebar-arrow-rotated.4b066557e16a8a50f50d2170eb2b5e8f.svg";
export { ForwardRef as ReactComponent };